import Vue from 'vue'

export const setCategoria = (state, payload) => {
  Vue.set(state, 'categoria', payload)
}

export const setCodArrecadacao = (state, payload) => {
  Vue.set(state, 'codArrecadacao', payload)
}

export const setInstituicao = (state, payload) => {
  Vue.set(state, 'instituicao', payload)
}
